import {PageFragment} from "@/shared/PageFragment";
import React from "react";
import {StyledEmpty} from "../../../shared/StyledComponents";

export class MessageCampaignsOverviewFragment extends PageFragment {

  renderContent(): React.ReactElement {
    return <StyledEmpty emptyConfig={{
      title: "Message Campaigns Overview",
      text: "Set up automatic message campaigns across multiple channels.\n\nStay in touch with your patients for better engagement.",
      iconUrl: "/images/message-campaigns.svg",
    }}/>
  }
}